import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-email-alt",
  templateUrl: "./med-icon-email-alt.component.html",
})
export class MedIconEmailAltComponent extends SvgMixinComponent {}
